export default "__VITE_ASSET__DEj$ls9y__"